import { useState } from 'react';
import { Favicon } from './Favicon';
import { BrowserBadge } from './BrowserBadge';
import type { BrowserName } from './BrowserBadge';

export interface TabRowProps {
  letter?: string;
  colorIndex?: number;
  title?: string;
  domain?: string;
  time?: string;
  browser?: BrowserName;
  dense?: boolean;
  onRestore?: () => void;
}

export function TabRow({
  letter = 'A',
  colorIndex = 0,
  title,
  domain,
  time,
  browser,
  onRestore,
  dense = false,
}: TabRowProps) {
  const [hover, setHover] = useState(false);
  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 11,
        height: dense ? 36 : 40,
        borderRadius: 8,
        padding: '0 8px',
        background: hover ? 'var(--surface-2)' : 'transparent',
        transition: 'none',
        fontFamily: 'var(--font-body)',
        color: 'var(--text-1)',
      }}
    >
      <Favicon letter={letter} index={colorIndex} size={18} ring="transparent" />
      <span style={{ fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flex: 1 }}>{title}</span>
      {domain && (
        <span
          style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 10,
            color: 'var(--text-3)',
            width: 150,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {domain}
        </span>
      )}
      {browser && <BrowserBadge browser={browser} size="sm" />}
      {time && <span style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--text-3)' }}>{time}</span>}
      <span
        onClick={onRestore}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 26,
          height: 26,
          borderRadius: 7,
          color: hover ? 'var(--text-1)' : 'var(--text-3)',
          cursor: 'pointer',
          background: hover ? 'var(--surface-3)' : 'transparent',
        }}
      >
        <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4.5 11.5l7-7M6.5 4.5h5v5" />
        </svg>
      </span>
    </div>
  );
}
